<template>
  <div>
  <section style="border-bottom: 0">
    <div class="left">
      <h2 v-translate>Promo nastavení</h2>
    </div>
    <div class="right">
      <div class="field_left">
        <checkbox-input
            id="promo_settings_enabled"
            v-model="entity.promo_settings.enabled"
            ref="promoenabledref"
            :disabled="!isEditable"
        >
          <translate class="translate">Vlastní uvítací obrazovka</translate>
        </checkbox-input>
      </div>
    </div>
  </section>
  <TranslationFormPart
      id="promopairingscreen"
      key="promopairingscreen"
      :form-settings="translationPairingScreenFormSettings"
      :disabled="!isPromoEditable"
      :bottom-border="false"
      v-model="entity.promo_settings.translations"
  />
  </div>
</template>

<script>

import TranslationFormPart from "../../../common/TranslationFormPart.vue";

export default {
  name: "PromoScreen",
  components: {TranslationFormPart},
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data(){
    return {
      translationPairingScreenFormSettings: [
        {
          name: "pairing_title",
          type: "text",
          title: this.$gettext("Titulek párovací obrazovky"),
          required: false,
        },
        {
          name: "pairing_promo_button_title",
          type: "text",
          title: this.$gettext("Text odkazu na promo stránku"),
          required: false,
        },
        {
          name: "pairing_body_html",
          type: "textarea",
          title: this.$gettext("HTML párovací obrazovky"),
          required: false,
        },
        {
          type: "empty",
        },
        {
          name: "promo_title",
          type: "text",
          title: this.$gettext("Titulek promo stránky"),
          required: false,
        },
        {
          name: "promo_back_button_title",
          type: "text",
          title: this.$gettext("Text odkazu na párovací stránku"),
          required: false,
        },
        {
          name: "promo_body_html",
          type: "textarea",
          title: this.$gettext("HTML promo obrazovky"),
          required: false,
        }
      ]
    }
  },
  computed: {
    isPromoEditable(){
      return this.isEditable && this.entity.promo_settings.enabled;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/initialProcessSetup/forms/PromoScreen.vue